module.exports = ".data{\r\n    /* float:right; */\r\n    padding:10px;\r\n    color:#ccc;\r\n}\r\n\r\n.heading{\r\n    padding:10px;\r\n    width:50%;\r\n}\r\n\r\n.datasheet{\r\n    width:60%;\r\n    margin:0px auto;\r\n    border:1px solid #ccc;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/petition/petition-approval/petition-approval.component.css
// module id = ./src/app/petition/petition-approval/petition-approval.component.css
// module chunks = main